import React from "react";
import { SidebarTrigger } from "@/components/ui/sidebar";

type PageHeaderProps = {
  title: string;
  subtitle?: string | JSX.Element;
  children?: React.ReactNode;
};

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  children,
}) => {
  return (
    <div className="sticky top-0 z-50 w-full bg-white border-b border-gray-200 py-3 px-4 sm:px-6 flex items-center justify-between">
      <div className="flex items-center gap-2">
        {/* Mobile burger menu - only visible on small screens */}
        <div className="lg:hidden">
          <SidebarTrigger className="p-2" />
        </div>
        <h1 className="text-lg font-medium">{title}</h1>
        {subtitle && (
          <span className="text-sm text-muted-foreground">{subtitle}</span>
        )}
      </div>
      <div className="flex items-center gap-2">
        {children}
        {/* Temporarily removed gift emoji button
        <Button
          variant="ghost"
          size="icon"
          className="text-2xl hover:bg-transparent p-0"
        >
          🎁
        </Button>
        */}
      </div>
    </div>
  );
};

export default PageHeader;
